export var buttonTexts;
(function (buttonTexts) {
    buttonTexts["NOTIFY_ME"] = "Notify Me";
    buttonTexts["ADDING"] = "Adding...";
    buttonTexts["ADD_TO_CART"] = "Add to Bag";
})(buttonTexts || (buttonTexts = {}));
export default {
    EMPTY: '',
    SELECT_TEXT: 'Select',
    OUT_OF_STOCK: 'Out of stock',
    MAX_RATING_COUNT: 5,
    MAX_DEVICE_WIDTH: 420,
    MAX_CARD_WIDTH: 184,
    MIN_CARD_WIDTH: 157,
    MIN_CARD_HEIGHT: 210,
    MAX_CARD_HEIGHT: 245,
    CARD_WIDTH_RATIO: 0.4,
    CARD_HEIGHT_RATIO: 0.533,
};
